<div class="email-verification">
  <p class="email-verification__message">Your email address successfully verified.</p>
  <p class="email-verification__submessage">
    You will be redirected to the application in {{ redirectTimer }} seconds.
  </p>
</div>
